import { Component, OnInit, NgZone, ChangeDetectorRef } from '@angular/core';
import { FileService } from '../../services/file.service';
import { FileNode, FileInfo } from '../../models/filenode';
import { Router, ParamMap, ActivatedRoute } from '@angular/router';
import { IsAdmin } from '../../guards/isAdmin';
import { DatePipe } from '@angular/common';
import { CurrentUserService } from '../../services/current-user.service';
import { Observable } from 'rxjs';
import { User } from '../../services/GI.Web.Services.g';

@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.css']
})
export class DownloadsComponent implements OnInit {
  private _user: User;

  constructor(
    private _fileService: FileService,
    private _currentUserService: CurrentUserService,
    private zone: NgZone,
    private router: Router,
    private _route: ActivatedRoute,
    public _adminGuard: IsAdmin
  ) {
    this._currentUserService.getUser().subscribe(u => {
      this._user = u;
      this.canShowAll = this._user.isAdmin || this._user.isArchiveUser || this._user.isBetaUser;
      this.updateFileList();
    });
  }

  public files: FileNode[];

  ngOnInit(): void {

    this._adminGuard.canActivate().subscribe(a => this.isAdmin = a);

    this._route.queryParamMap.switchMap(p => {
      let file = p.get('file');
      if (!file) return Observable.empty();
      return this._fileService.getUrl(file);
    }).subscribe((f: string) => {
      window.location.href = f;
    });
  }

  private updateFileList() {
    this._fileService.getFilesTree(this._user.isArchiveUser && this.showAll, this._user.isBetaUser && this.showAll, this._user.isAdmin && this.showAll).subscribe(f => {
      this.files = f;
    }
    );
  }

  public isAdmin: boolean;

  public canShowAll: boolean

  private _showAll: boolean
  public get showAll(): boolean {
    return this._showAll;
  }

  public set showAll(value: boolean) {
    if (value != this._showAll) {
      this._showAll = value;
      this.updateFileList();

    }
  }

  private static filterLatest(files: FileNode[]): FileNode[] {
    let trimmedTree: FileNode[] = [];
    files.forEach(file => {
      let filteredNode = file.clone();
      if (file.children.length > 0) {
        filteredNode.children.push(file.children[0]);
      }
      trimmedTree.push(filteredNode);
    });
    return trimmedTree;
  }

  public toggleBeta(file: FileInfo) {
    file.beta = !file.beta;
    this._fileService.setProperties(file).subscribe();
  }
  public changeProperties(file: FileInfo) {
    this._fileService.setProperties(file).subscribe();
  }

  public showMarkdown(file: string) {
    this.router.navigate(['/view', file]);

  }




}



// WEBPACK FOOTER //
// ./src/app/components/downloads/downloads.component.ts